import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';
import * as globals from '../training/globals';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {

  private appInsights!: ApplicationInsights;

  init(): void {

    if (!environment.appInsightsConnectionString) {
      return;
    }

    const appInsightsConnectionString = CryptoJS.AES.decrypt(environment.appInsightsConnectionString, environment.clientId)
    .toString(CryptoJS.enc.Utf8);

    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: appInsightsConnectionString,
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        maxBatchInterval: 10000
      }
    });

    this.appInsights.loadAppInsights();

    // ✅ Set Cloud Role Name
    this.appInsights.addTelemetryInitializer((envelope) => {
      envelope.tags = envelope.tags || {};
      envelope.tags[globals.aiCloudRole] = globals.appName;
    });
  }

  get instance(): ApplicationInsights {
    return this.appInsights;
  }
}
